import { HEADERS } from './fixtures';
import React from 'react';
import { StatisticsLayout } from 'views/components';
import { campaignActions } from 'core/Campaign';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
    ButtonFooter,
    Container,
    ExpandButton,
    PageController,
    Table
} from 'mol-ui';
import {
    useDispatch,
    useSelector
} from 'hooks';

const CampaignListing = () => {

    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { push } = useHistory();

    const {
        list,
        loading
    } = useSelector('campaign');

    const getData = params => {
        dispatch(campaignActions.getCampaigns(params));
    };

    const actionHandler = [{
        icon: 'search',
        onClick: ({ id }) => push(`${ t('/campanas/editar') }/${ id }`),
        title: t('Editar')
    }, {
        icon: 'content_copy',
        onClick: ({ id }) => push(`${ t('/campanas/clonar') }/${ id }`),
        title: t('Clonar')
    }];

    const handleNewCampaign = () => {
        dispatch(campaignActions.setCampaignParticipants(null));
        dispatch(campaignActions.setCampaignSelected(null));
        push(t('/campanas/crear'));
    };

    const { data } = list?.getData() ?? { data: [] };

    return (
        <StatisticsLayout
            filterCompanies={ false }
            filterProfessionals={ false }
            filterSpecialties={ false }
            initialFilters={{
                end_date: moment().add(1, 'month').endOf('month').format('YYYY-MM-DD')
            }}
            title={ t('Campañas') }
            onFiltersChange={ getData }
        >
            <Container flex="1">
                <Table
                    config={ HEADERS }
                    data={ data }
                    loading={ loading }
                    rowActions={ actionHandler }
                />
                {
                    !loading &&
                    <PageController
                        controller={ list }
                        height="20px"
                    />
                }
            </Container>
            <ButtonFooter margin="0px 0px 20px 0px">
                <ExpandButton
                    caption={ t('Nueva campaña') }
                    icon="add"
                    size={ 80 }
                    width={ 160 }
                    onClick={ handleNewCampaign }
                />
            </ButtonFooter>
        </StatisticsLayout>
    );
};

export default CampaignListing;
